// extracted by mini-css-extract-plugin
export default {"input":"components__input--6hP"};